import { ILogger } from '@cian/logger';
import { IHttpApi } from '@cian/http-api';
import { fetchGetUserData } from '../../repositories/users/v1/get-user-data/apiHelpers';
import { TGetUserDataResponse } from '../../repositories/users/v1/get-user-data/types';
import { TUser } from '../../types/user/user';
import { UnknownError } from '@cian/peperrors';
import { userMapper } from '../../mappers';

interface IUserResolve {
  user: TUser;
}

export async function getUser(httpApi: IHttpApi, logger: ILogger, cookie?: string): Promise<IUserResolve> {
  try {
    const userDataByRequestDataResponse: TGetUserDataResponse = await fetchGetUserData({
      httpApi,
      config: {
        requestConfig: {
          headers: [['cookie', cookie || '']],
        },
      },
    });

    return {
      user: userMapper(userDataByRequestDataResponse.response.user),
    };
  } catch (err) {
    if (err.statusCode === 400) {
      return { user: null };
    }

    logger.error(
      new UnknownError({
        message: 'Ошибка получения данных lk-type',
        domain: 'src/shared/services/getUser/getUser.ts',
        details: err as UnknownError,
      }),
    );

    return {
      user: null,
    };
  }
}
